// hooks
import useLocales from '../../../hooks/useLocales';
// components
import Image from '../../../components/Image';
import { IconButtonAnimate } from '../../../components/animate';

// ----------------------------------------------------------------------

export default function LanguagePopover() {
  const { allLang, currentLang, onChangeLang } = useLocales();
  return (
    <>
      {allLang
        .filter((option) => currentLang.value !== option.value)
        .map((option) => (
          <IconButtonAnimate
            key={option.value}
            onClick={() => onChangeLang(option.value)}
            sx={{
              width: 40,
              height: 40,
            }}
          >
            <Image disabledEffect src={option.icon} alt={option.label} />
          </IconButtonAnimate>
        ))}
    </>
  );
}
